import {CALL_API} from 'redux-api-middleware';
import {
  API_PROGRAM_LIST_GET_REQUEST,
  API_PROGRAM_LIST_GET_SUCCESS,
  API_PROGRAM_LIST_GET_FAILURE,
  API_PROGRAM_GET_BY_APPROVED_STATUS_REQUEST,
  API_PROGRAM_GET_BY_APPROVED_STATUS_SUCCESS,
  API_PROGRAM_GET_BY_APPROVED_STATUS_FAILURE,
} from 'common/types';
import {ENDPOINT_PROGRAM} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

export default {
  getProgramList: (token, params) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_PROGRAM}programs/${params}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_PROGRAM_LIST_GET_REQUEST,
          API_PROGRAM_LIST_GET_SUCCESS,
          API_PROGRAM_LIST_GET_FAILURE,
        ],
      },
    };
  },
  getProgramsByApprovedStatus: (token, params) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_PROGRAM}programs?status=Approved`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_PROGRAM_GET_BY_APPROVED_STATUS_REQUEST,
          API_PROGRAM_GET_BY_APPROVED_STATUS_SUCCESS,
          API_PROGRAM_GET_BY_APPROVED_STATUS_FAILURE,
        ],
      },
    };
  },
};
